import { amountFormat } from "../../../utils/amountFormat";

export type PayoutAccount = {
  id: string;
  name: string;
  school: string;
  bank: string;
  logoUrl: string;
  accountNumber: string;
  ifsc: string;
  currency: string;
  addedOn: string;
  accountType?: string;
  holderName?: string;
  branchName?: string;
  branchCity?: string;
  useForPayouts?: boolean;
  useForSettlements?: boolean;
  primary?: boolean;
  status?: string;
  createdBy?: string;
  verificationStatus?: string;
  availableBalance: number;
  accountBalance: number;
  fundsOnHold: number;
  overdraftBalance: number;
  overdraftLimit: number;
  lowBalanceThreshold: number;
  accent: string;
};

export type RecentPayout = {
  referenceId: string;
  utrNumber: string;
  beneficiary: string;
  account: string;
  accountId: string;
  purpose: string;
  amount: number;
  status: string;
  settlementTime: string;
};

export const payoutAccounts: PayoutAccount[] = [
  {
    id: "operating",
    name: "Operating Account",
    school: "Green Valley Public School",
    bank: "HDFC Bank",
    logoUrl:
      "https://upload.wikimedia.org/wikipedia/commons/2/28/HDFC_Bank_Logo.svg",
    accountNumber: "4589",
    ifsc: "HDFC0004589",
    currency: "INR",
    addedOn: "14 Mar 2025, 01:07 PM",
    availableBalance: 24385230,
    accountBalance: 25000000,
    fundsOnHold: 520000,
    overdraftBalance: 80000,
    overdraftLimit: 500000,
    lowBalanceThreshold: 100000,
    accent: "bg-[#E53935]",
  },
  {
    id: "salary",
    name: "Salary Account",
    school: "Green Valley Public School",
    bank: "ICICI Bank",
    logoUrl:
      "https://upload.wikimedia.org/wikipedia/commons/1/12/ICICI_Bank_Logo.svg",
    accountNumber: "9034",
    ifsc: "ICIC0009034",
    currency: "INR",
    addedOn: "18 Mar 2025, 11:20 AM",
    availableBalance: 7450000,
    accountBalance: 7600000,
    fundsOnHold: 100000,
    overdraftBalance: 50000,
    overdraftLimit: 250000,
    lowBalanceThreshold: 50000,
    accent: "bg-[#F97316]",
  },
  {
    id: "scholarship",
    name: "Scholarship Account",
    school: "Green Valley Public School",
    bank: "Axis Bank",
    logoUrl:
      "https://upload.wikimedia.org/wikipedia/commons/c/ce/Axis_Bank_logo.svg",
    accountNumber: "1123",
    ifsc: "UTIB0001123",
    currency: "INR",
    addedOn: "22 Mar 2025, 03:45 PM",
    availableBalance: 1924000,
    accountBalance: 2000000,
    fundsOnHold: 60000,
    overdraftBalance: 16000,
    overdraftLimit: 150000,
    lowBalanceThreshold: 25000,
    accent: "bg-[#BE123C]",
  },
  {
    id: "vendor",
    name: "Vendor Account",
    school: "Green Valley Public School",
    bank: "State Bank of India",
    logoUrl:
      "https://upload.wikimedia.org/wikipedia/en/5/58/State_Bank_of_India_logo.svg",
    accountNumber: "7781",
    ifsc: "SBIN0007781",
    currency: "INR",
    addedOn: "28 Mar 2025, 10:12 AM",
    availableBalance: 4192000,
    accountBalance: 4300000,
    fundsOnHold: 90000,
    overdraftBalance: 18000,
    overdraftLimit: 300000,
    lowBalanceThreshold: 75000,
    accent: "bg-[#2563EB]",
  },
];

export const recentPayouts: RecentPayout[] = [];

export const totalAvailableBalance = payoutAccounts.reduce(
  (sum, account) => sum + account.availableBalance,
  0,
);

export const payoutQuickStats = [
  {
    label: "Today's Payouts",
    value: `\u20B9${amountFormat(235000)}`,
  },
  {
    label: "Pending Approvals",
    value: `\u20B9${amountFormat(75000)}`,
  },
  {
    label: "Successful Transfers",
    value: `\u20B9${amountFormat(180000)}`,
  },
  {
    label: "Total Beneficiaries",
    value: "1,254",
  },
];
